import { render, staticRenderFns } from "./InstList.vue?vue&type=template&id=47997c01&scoped=true&"
import script from "./InstList.vue?vue&type=script&lang=js&"
export * from "./InstList.vue?vue&type=script&lang=js&"
import style0 from "./InstList.vue?vue&type=style&index=0&id=47997c01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47997c01",
  null
  
)

export default component.exports